module.exports = __webpack_public_path__ + "static/media/companyAndAddress.539e77a0.xlsx";